import { isNumber } from "lodash-es";

type Node = {
  __typename?: "CropParameterConnectionEdge";
  node?:
    | {
        __typename: "FloatCropParameter";
        min?: number | null;
        max?: number | null;
        unit?: string | null;
        id?: string | null;
        title?: string | null;
      }
    | {
        __typename?: "SelectCropParameter";
        id?: string | null;
        title?: string | null;
      }
    | {
        __typename: "TextCropParameter";
        title?: string | null;
        textDefault?: string | null;
        id?: string | null;
      }
    | null;
} | null;

const mapCropParameter = (node: Node) => {
  switch (node?.node?.__typename) {
    case "TextCropParameter":
      return [node.node.title, node.node.textDefault];
    case "FloatCropParameter": {
      const unit = node.node.unit ?? "%";

      if (isNumber(node.node.min) && isNumber(node.node.max)) {
        return [
          node.node.title,
          [node.node.min, node.node.max].join("-"),
          unit,
        ];
      }

      if (isNumber(node.node.min)) {
        return [node.node.title, ["min.", node.node.min, unit].join(" ")];
      }

      if (isNumber(node.node.max)) {
        return [node.node.title, ["max.", node.node.max, unit].join(" ")];
      }
      return [];
    }
    default:
      return [];
  }
};

const sortCropParameter = (
  a?: (string | null | undefined)[],
  b?: (string | null | undefined)[],
) => {
  const priority: Record<string, number> = {
    Ca: 4,
    "K₂O": 2,
    Mg: 3,
    N: 0,
    "P₂O₅": 1,
    S: 5,
  };
  const defaultPriority = Object.keys(priority).length;
  const aLabel = a?.at(0) ?? undefined;
  const bLabel = b?.at(0) ?? undefined;

  if (!(aLabel && bLabel)) {
    return 0;
  }
  const rankA = priority[aLabel] ?? defaultPriority;
  const rankB = priority[bLabel] ?? defaultPriority;

  if (rankA !== rankB) {
    return rankA - rankB;
  }
  return aLabel.localeCompare(bLabel);
};

export { mapCropParameter, sortCropParameter };
